module.exports = __webpack_public_path__ + "files/2e75ad8a476a796abcc2e6e70f63ed5c.png";